<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li>{{ this.$t('user_group.users') }}</li>
            <li>{{ $t('general.user_hierarchy_schema') }}</li>
          </ul>
        </nav>
      </div>
      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left" />
        <!-- <div class="section-header-right">
          <button aria-expanded="false" class="btn btn-default" type="button" @click="downloadHierarchyPdf">
            Pdf indir
          </button>
          <button aria-expanded="false" class="btn btn-default" type="button" @click="printHierarchy">
            Yazdır
          </button>
        </div> -->
      </div>
      <div ref="orgchartPdfContainer" style="overflow: visible;">
        <organization-chart :datasource="ds">
          <template #default="{ nodeData }">
            <div class="node-card">
              <img v-if="nodeData.photo" :src="nodeData.photo" class="photo" />
              <div class="name">{{ nodeData.name }}</div>
              <div class="title">{{ nodeData.title }}</div>
            </div>
          </template>
        </organization-chart>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationChart from 'vue-organization-chart'
import 'vue-organization-chart/dist/orgchart.css'
import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default {
  name: "Hierarchy",
  components: { OrganizationChart },
  data() {
    return {
      successMessage: null,
      ds: {}
    };
  },
  methods: {
    async downloadHierarchyPdf() {
      const element = this.$refs.orgchartPdfContainer;
      if (!element) return;

      const fullWidth = element.scrollWidth;
      const fullHeight = element.scrollHeight;

      const canvas = await html2canvas(element, {
        width: fullWidth,
        height: fullHeight,
        scrollX: -window.scrollX,
        scrollY: -window.scrollY,
        windowWidth: document.documentElement.scrollWidth,
        windowHeight: document.documentElement.scrollHeight,
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff"
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("landscape", "pt", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("organizasyon-semasi.pdf");
    },
    printHierarchy() {
      const element = this.$refs.orgchartPdfContainer;
      if (!element) return;

      const printWindow = window.open('', '', 'width=1000,height=800');
      if (!printWindow) return;

      printWindow.document.write(`
      <html>
        <head>
          <title>${this.$t("general.hierarchy_schema")}</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            .node-card {
              background: #ffffff;
              padding: 14px 18px;
              border-radius: 10px;
              border: 1px solid #e3e6eb;
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
              min-width: 180px;
              text-align: center;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin: 5px;
            }
            .node-card .name {
              font-size: 14px;
              font-weight: 600;
              color: #2d3a4a;
            }
          </style>
        </head>
        <body>
          ${element.innerHTML}
        </body>
      </html>
    `);

      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    },
    mapOrgData(list) {
      return list.map(item => ({
        id: String(item.id),
        name: `${item.name} ${item.surname}`,
        title: item.position?.name ?? this.$t("general.manager"),
        children: item.children_recursive?.length
          ? this.mapOrgData(item.children_recursive)
          : [],
      }));
    },
    getHierarchyTree() {
      axios.get('/api/company-hierarchy-tree')
        .then((response) => {
          this.ds = {
            id: 'root',
            name: '',
            children: this.mapOrgData(response.data),
          };
        })
        .catch((error) => {
          console.error(error);
        });
    }
  },
  mounted() {
    this.getHierarchyTree();
  },
};
</script>

<style scoped>
::v-deep .orgchart {
  background: transparent !important;
  background-image: none !important;
  width: auto !important;
  height: auto !important;
  overflow: visible !important;
}

::v-deep .node-card .title {
  height: 1.5rem;
  display: block !important;
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
  background-color: #4a90e2;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 4px;
  padding-bottom: 4px;
  margin-top: 6px;
  border-radius: 6px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

::v-deep .node-card {
  background: #ffffff;
  padding: 14px 18px;
  border-radius: 10px;
  border: 1px solid #e3e6eb;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  min-width: 180px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.25s ease;
}

::v-deep .node-card .name {
  font-size: 14px;
  font-weight: 600;
  color: #2d3a4a;
}

::v-deep .orgchart .lines .downLine {
  background-color: #c4c9d4 !important;
}

::v-deep .orgchart .lines .leftLine,
::v-deep .orgchart .lines .rightLine,
::v-deep .orgchart .lines .topLine {
  border-color: #c4c9d4 !important;
}

::v-deep .orgchart li {
  padding: 0 24px !important;
}

::v-deep td {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

::v-deep .orgchart .node.focused,
::v-deep .orgchart .node:hover {
  background: none !important;
  box-shadow: none !important;
  border: none !important;
}

::v-deep .orgchart>table>tbody>tr:nth-child(-n+3) {
  display: none !important;
}
</style>
